export enum AjaxErrorType {
    NetworkError,
    ServerError,
    ClientError,
    FormatError
}

export type AjaxError = {
    type: AjaxErrorType;
    status: number;
    statusText: string;
    title: string;
    body: any;
    handled?: boolean;
};
